import React, { useEffect } from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';

import SignUpContainer from '@explorer/containers/userauth/SignUpContainer';

const Login = () => {
    useEffect(() => {
        document.body.id = 'login-page';
    }, []);

    return (
        <>
            <HelmetProvider>
                <Helmet
                    meta={[
                        { property: 'keywords', content: 'Learning Korean, Korean explorer, Korean analyzer, Korean grammar, sentence analyzer, learning language, Study Korean, AI learning language, k-pop, k-drama' },
                        { property: 'description', content: 'Search for and display Korean Grammar and Idiom patterns and explanations' },
                    ]}
                >
                    <title>Mirinae Korean Language Explorer</title>
                </Helmet>
            </HelmetProvider>
            <SignUpContainer theme="login" />
        </>
    );
};

export default Login;
